import overrideIfMinBetNumberEnabled from "./MinBetNumberRegistrator";
overrideIfMinBetNumberEnabled(function () {
    (function (comboSPSlipMode) {
        if (!comboSPSlipMode) {
            return;
        }
        var _setDefaultStake = comboSPSlipMode.setDefaultStake;
        $.extend(comboSPSlipMode, {
            setDefaultStake(options) {
                return options.isMinBetNumberValid
                    ? _setDefaultStake.call(this, options)
                    : "0";
            }
        });
    })(window.ComboSPSlipMode.prototype);
    BetSlip.OnLoaded["ComboSPSlipModeWithMBN"] = function (betSlip) {
        if (!(betSlip && betSlip.CurrentMode)) {
            return;
        }
        betSlip.CurrentMode.setDefaultStake = function (options) {
            return window.ComboSPSlipMode.prototype.setDefaultStake.call(betSlip.CurrentMode, options);
        };
    };
});
//# sourceMappingURL=ComboSPSlipMode.js.map